"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LoadControl_1 = __importDefault(require("@/class/LoadControl"));
const selectLoad = new LoadControl_1.default();
exports.default = selectLoad;
